import React from 'react'
import PropTypes from 'prop-types';
import { buttonWrap } from './button.module.scss'


function Button({ 
    color = 'grey', 
    handleClick, 
    text, 
    textColor = 'black'
 }){
    return (
        <button
            type="button" 
            tabIndex="0"
            onClick={() => handleClick()}
            style={{backgroundColor: color, background: color, color: textColor}}
            className={buttonWrap}
        >
            <span>{text}</span>
        </button> 
    )
}

Button.propTypes = {
    color: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    textColor: PropTypes.string
}

export default Button